import styled from 'styled-components';

import {
  Avatar,
} from 'web-components';

export const ClientInfo = styled.div`
  height: 250px;
  width: 100%;
  background-color: ${props => props.theme.colors.baseBanner};
`;

export const StyledAvatar = styled(Avatar).attrs({
  width: '140px',
  height: '140px',
  bgColor: 'transparent',
  placeholderSize: 48,
})`
  border: 3px solid #fff;
  border-radius: 50%;
`;

export const ClientSummary = styled.table`
  font-size: 13px;
  border-collapse: collapse;

  & td {
    padding-bottom: 10px;
  }

  & tr > td:first-of-type {
    color: #fff;
    border-right: 1px solid #fff;
    padding-right: 10px;
    text-transform: uppercase;
  }

  & tr > td:last-of-type {
    color: #fff;
    padding-left: 10px;
    text-transform: uppercase;
  }
`;
